import React from 'react'

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white shadow-sm py-4 px-6 flex items-center justify-between">
        <a href="/" className="text-xl font-bold text-black">Jenny Kids</a>
        <a href="/" className="text-sm text-gray-600 hover:text-black transition-colors">← Volver al inicio</a>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
        <p className="text-sm text-gray-500 mb-10">Última actualización: 26 de abril de 2026</p>

        <div className="space-y-8 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Responsable del tratamiento</h2>
            <p>
              <strong>Jenny Kids</strong>, con domicilio en Bogotá D.C., Colombia, es responsable del
              tratamiento de los datos personales recopilados a través del sitio web
              <strong> www.jennykids.com.co</strong>.
            </p>
            <p className="mt-2">Contacto: <a href="mailto:gonzgonc@gmail.com" className="text-blue-600 underline">gonzgonc@gmail.com</a></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Datos que recopilamos</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nombre completo</li>
              <li>Número de documento de identidad (CC, CE, TI, NIT o Pasaporte)</li>
              <li>Correo electrónico</li>
              <li>Número de celular</li>
              <li>Dirección de envío en Colombia (departamento, municipio, barrio y dirección)</li>
            </ul>
            <p className="mt-3">
              Cuando usas "Continuar con Google", recopilamos únicamente tu nombre y correo
              electrónico verificados por Google. No accedemos a tu correo, contactos ni ningún
              otro dato de tu cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Finalidad del tratamiento</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Gestionar y coordinar tu pedido de ropa infantil</li>
              <li>Contactarte para confirmar disponibilidad, tallas y envío</li>
              <li>Enviar información sobre novedades y ofertas (solo si lo autorizas)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Base legal</h2>
            <p>
              El tratamiento de tus datos se realiza con base en tu consentimiento expreso,
              conforme a la <strong>Ley 1581 de 2012</strong> (Ley de Protección de Datos
              Personales de Colombia) y sus decretos reglamentarios.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Compartición de datos</h2>
            <p>
              No vendemos ni cedemos tus datos a terceros. Únicamente los compartimos con:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Supabase</strong> — plataforma de base de datos segura donde se almacenan tus datos</li>
              <li><strong>Transportistas</strong> — únicamente la dirección de envío para entrega del pedido</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Conservación de datos</h2>
            <p>
              Conservamos tus datos durante el tiempo necesario para gestionar tu pedido y
              cumplir obligaciones legales. Puedes solicitar su eliminación en cualquier momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Tus derechos (Habeas Data)</h2>
            <p>De acuerdo con la Ley 1581 de 2012, tienes derecho a:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li><strong>Conocer</strong> los datos que tenemos sobre ti</li>
              <li><strong>Actualizar</strong> o corregir datos incorrectos</li>
              <li><strong>Suprimir</strong> tus datos de nuestra base</li>
              <li><strong>Revocar</strong> el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-3">
              Para ejercer estos derechos escríbenos a{' '}
              <a href="mailto:gonzgonc@gmail.com" className="text-blue-600 underline">gonzgonc@gmail.com</a>.
              Respondemos en máximo <strong>10 días hábiles</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Seguridad</h2>
            <p>
              Implementamos medidas técnicas y organizativas para proteger tus datos:
              cifrado HTTPS, almacenamiento en servidores seguros (Supabase/AWS) y
              acceso restringido solo al personal autorizado.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Cambios en esta política</h2>
            <p>
              Podemos actualizar esta política ocasionalmente. La fecha de última actualización
              aparece al inicio del documento. Te notificaremos cambios significativos por correo
              electrónico si ya eres cliente registrado.
            </p>
          </section>

          <section className="bg-gray-50 rounded-xl p-5 border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Contacto</h2>
            <p>Para consultas sobre privacidad o ejercicio de derechos:</p>
            <ul className="mt-2 space-y-1">
              <li><strong>Email:</strong> <a href="mailto:gonzgonc@gmail.com" className="text-blue-600 underline">gonzgonc@gmail.com</a></li>
              <li><strong>Sitio web:</strong> <a href="https://www.jennykids.com.co" className="text-blue-600 underline">www.jennykids.com.co</a></li>
              <li><strong>Ubicación:</strong> Bogotá D.C., Colombia</li>
            </ul>
          </section>

        </div>
      </main>

      <footer className="border-t border-gray-100 py-6 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Jenny Kids — Bogotá, Colombia
      </footer>
    </div>
  )
}

export default Privacy
